<app-data-table mainTitle="Localidade Grupo"
                singleTitle="Localidade Grupo"
                routerPath="/localidade-grupo"
                entityPath="/localidadegrupo"
                [entity]="localidadeGrupo"
                [entityFilter]="entityFilter"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
